jQuery(document).ready(function($) {

    //slider
    $('#single-slider').slick({
        dots: true,
        arrows: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $('.slider-products').slick({
        dots: false,
        arrows: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        appendArrows: $('.products .arrows'),
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.slider-info').slick({
        dots: false,
        arrows: false,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
    });

    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        dots: false,
    });

    /**
     * file
     */
    $('.link-file').on('click', function (e) {
        e.preventDefault();
        $(this).closest('div').find(':file').click()
    })


    /**
     * Меню
     */
    /**
     * Меню для мобильного
     */
    $('.btn-menu').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.sticky').toggleClass('active');

        if ($(this).hasClass('active')) {
            $('body').css('overflow', 'hidden');
        } else {
            $('body').css('overflow', 'visible');
        }
    });


    $('#nav a').on('click', function (e) {
        if ($(window).width() < 1199) {
            let thisParent = $(this).closest('li'),
                ul = thisParent.find('> ul');
            if (ul.length > 0) {
                e.preventDefault();
                thisParent.toggleClass('open').siblings().removeClass('open').find('> ul').slideUp();
                ul.slideToggle();
            }
        }
    });

    /**
     * табы
     */

    $('#tabs').on('click', 'li:not(.active)', function() {
        $(this).addClass('active').siblings().removeClass('active').parents().find('.box').eq($(this).index()).fadeIn(150).siblings('.box').hide();
    });

    /**
     * Опции
     */
    $('.option-switch').on('click', function () {
        let $this = $(this);

        $this.closest('.option').siblings().find('.option-values').slideUp();
        $this.next().slideToggle();
    });

    /**
     * Корзина
     */
    $('.link-basket').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);

        $this.closest('.option').siblings().find('.option-values').slideUp();
        $this.next().slideToggle();
    });

    /**
     * Кол-во
     */
    $('.count a').on('click', function (e) {
        e.preventDefault();
        let inputCount = $(this).parents('.count').find('input');
        let count = parseInt(inputCount.val());
        if ($(this).hasClass('plus')) {
            count++;

        } else if ($(this).hasClass('minus') && count > 1) {
            count--;
        }
        inputCount.val(count);
    });
});

